import { render } from "./ServicosPage.vue?vue&type=template&id=1fc2d7a6&scoped=true"
import script from "./ServicosPage.vue?vue&type=script&lang=js"
export * from "./ServicosPage.vue?vue&type=script&lang=js"

import "./ServicosPage.vue?vue&type=style&index=0&id=1fc2d7a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc2d7a6"]])

export default __exports__